import React from "react";

import _ from "lodash";

const TableFooter = ({ summary, columns, total }) => {
  const renderCell = (item, column) => {
    if (column.path === "id") return "مجموعه";

    if (column.content) return column.content(item);

    return _.get(item, column.path);
  };

  const createKey = (item, column) => {
    return item.id + (column.path || column.key);
  };

  return (
    <tfoot className="row-total">
      <tr>
        {summary &&
          columns &&
          columns.map((column) => (
            <td key={createKey(summary, column)}>
              {renderCell(summary, column)}
            </td>
          ))}

        {total ? (
          <React.Fragment>
            <td colSpan={columns.length - 2}>مجموعه</td>
            <td colSpan={2}>{total}</td>
          </React.Fragment>
        ) : null}
      </tr>
    </tfoot>
  );
};

export default TableFooter;
